const c = {
  name: "Chicago",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M1.5,9C3.1,6.4,6.2,4,12,4c5.8,0,8.9,2.4,10.5,5c0.8,1.2,1.1,2.5,1.3,3.4c0.1,0.5,0.1,0.9,0.2,1.1
			c0,0.1,0,0.3,0,0.3c0,0,0,0.1,0,0.1l0,0l0,0v0v0c0,0,0,0-1,0c1,0,1,0,1,0v0v0l0,0l0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.2
			c0,0.2,0,0.4-0.1,0.7c-0.1,0.5-0.3,1.3-0.6,2c-0.4,0.7-0.9,1.5-1.8,2.1c-0.9,0.6-2,0.9-3.4,0.9c-1.4,0-2.4-0.3-3.2-0.8
			c-0.8-0.5-1.2-1.2-1.5-1.8c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.3-0.3-0.4C12.6,16.1,12.5,16,12,16
			s-0.6,0.1-0.7,0.3c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c-0.3,0.6-0.7,1.2-1.5,1.8
			C8.4,19.7,7.4,20,6,20c-1.4,0-2.6-0.4-3.4-0.9c-0.9-0.6-1.5-1.4-1.8-2.1c-0.4-0.7-0.5-1.5-0.6-2C0,14.7,0,14.4,0,14.3
			c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1l0,0l0,0l0,0l0,0c0,0,0,0,1,0c-1,0-1,0-1,0l0,0l0,0l0,0l0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3
			c0-0.3,0.1-0.7,0.2-1.1C0.4,11.5,0.8,10.2,1.5,9z M2,14L2,14c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0.1,0.5c0.1,0.4,0.2,0.9,0.5,1.4
			c0.3,0.5,0.6,1,1.1,1.3C4.2,17.7,4.9,18,6,18c1.1,0,1.7-0.2,2.1-0.5c0.3-0.2,0.6-0.5,0.8-1C8.9,16.4,9,16.3,9,16.2l0,0
			c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.3,0.3-0.6,0.5-0.8c0.5-0.6,1.2-1,2.3-1s1.8,0.4,2.3,1c0.2,0.3,0.4,0.6,0.5,0.8
			c0.1,0.1,0.1,0.3,0.2,0.4l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.4,0.4,0.8,0.8,1c0.4,0.2,1,0.5,2.1,0.5c1.1,0,1.8-0.3,2.3-0.6
			c0.5-0.4,0.9-0.8,1.1-1.3c0.3-0.5,0.4-1,0.5-1.4c0-0.2,0-0.4,0.1-0.5c0-0.1,0-0.1,0-0.1l0,0v0c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2
			c0-0.2-0.1-0.5-0.1-0.9C21.7,12,21.4,11,20.8,10c-1.2-1.9-3.6-4-8.8-4c-5.2,0-7.6,2.1-8.8,4c-0.6,1-0.9,2-1.1,2.8
			C2.1,13.2,2,13.5,2,13.7C2,13.8,2,13.9,2,14C2,14,2,14,2,14L2,14z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Chicago
};
